// Best-effort city -> region mapping for grouping the route city filter (Spanish autonomous
// communities plus a few other countries). Keyed by normalized (trim + lowercase) city name.
// Cities not listed here are left ungrouped.
const CITY_TO_REGION: {[normalizedCity: string]: string} = {
  // Catalunya
  'barcelona': 'Catalunya',
  'sarrià-sant gervasi': 'Catalunya',
  'sant joan despi': 'Catalunya',
  "l'hospitalet de llobregat": 'Catalunya',
  'cornellà del llobregat': 'Catalunya',
  'vic': 'Catalunya',
  'esplugues de llobregat': 'Catalunya',
  'martorell': 'Catalunya',
  'montcada i reixac': 'Catalunya',
  'rubi': 'Catalunya',
  'santa perpetua de mogoda': 'Catalunya',
  'sant just desvern': 'Catalunya',
  'viladecans': 'Catalunya',
  'sant andreu de la barca': 'Catalunya',
  'santa coloma de gramanet': 'Catalunya',
  'sant feliu del llobregat': 'Catalunya',
  'sant celoni': 'Catalunya',
  'palau-solità i plegamans': 'Catalunya',
  'sant fost de campsentelles': 'Catalunya',
  'badalona': 'Catalunya',
  'vilanova i la geltrú': 'Catalunya',
  'manresa': 'Catalunya',
  'terrassa': 'Catalunya',
  'castelldefels': 'Catalunya',
  'sant cugat del valles': 'Catalunya',
  'girona': 'Catalunya',
  'sabadell': 'Catalunya',
  'abrera': 'Catalunya',
  'cervello': 'Catalunya',
  'el prat de llobregat': 'Catalunya',
  'sant quirze del valles': 'Catalunya',
  'pallejà': 'Catalunya',
  'reus': 'Catalunya',
  'igualada': 'Catalunya',
  'sant boi de llobregat': 'Catalunya',
  'la rápita': 'Catalunya',

  // Comunidad de Madrid
  'madrid': 'Comunidad de Madrid',
  'las rozas': 'Comunidad de Madrid',
  'pozuelo de alarcon': 'Comunidad de Madrid',
  'alcala de henares': 'Comunidad de Madrid',
  'alcobendas': 'Comunidad de Madrid',
  'san sebastián de los reyes': 'Comunidad de Madrid',
  'getafe': 'Comunidad de Madrid',
  'rivas-vaciamadrid': 'Comunidad de Madrid',
  'valdemoro': 'Comunidad de Madrid',
  'torrejón de ardoz': 'Comunidad de Madrid',

  // Illes Balears
  'palma': 'Illes Balears',
  'ciutadella de menorca': 'Illes Balears',

  // Galicia
  'la coruña': 'Galicia',
  'santiago de compostela': 'Galicia',

  // Región de Murcia
  'molina de segura': 'Región de Murcia',

  // Castilla y León
  'salamanca': 'Castilla y León',

  // Comunitat Valenciana
  'valencia': 'Comunitat Valenciana',
  'benidorm': 'Comunitat Valenciana',
  'alfafar': 'Comunitat Valenciana',
  'torrent': 'Comunitat Valenciana',

  // Andalucía
  'sevilla': 'Andalucía',
  'málaga': 'Andalucía',
  'benahavís': 'Andalucía',

  // Comunidad Foral de Navarra
  'pamplona': 'Comunidad Foral de Navarra',

  // País Vasco
  'bilbao': 'País Vasco',
  'baracaldo': 'País Vasco',

  // Reino Unido
  'london': 'Reino Unido',
};

export function regionForCity(city: string): string | null {
  return CITY_TO_REGION[city.trim().toLowerCase()] || null;
}
